/**
 * 快递询价管理前端接口
 */

import { request } from '@/utils/http'
import { type BatchDeleteRequest, type PageResponse } from '@/api/types/common'
import {
  type InquiryBaseModel,
  type InquiryPageRequest,
  type InquirySaveRequest
} from './inquiry-base'

export interface InquiryExpressModel extends InquiryBaseModel {
  stuffingWarehouseId?: string | null
  loadMode?: string | null
  paymentTerm?: string | null
  serviceType?: string | null
  onePriceSupported?: boolean | null
  hsCode?: string | null
  specialRequirements?: string | null
  routeType?: string | null
  needPickup?: boolean | null
  needDelivery?: boolean | null
  needUpstairs?: boolean | null
  needLoadingUnloading?: boolean | null
  expectedVehicleType?: string | null
  expectedTransitTime?: string | null
  pricingPreference?: string | null
}

export interface InquiryExpressPageRequest extends InquiryPageRequest {}

export interface InquiryExpressSaveRequest extends InquirySaveRequest {
  stuffingWarehouseId?: string | null
  loadMode?: string | null
  paymentTerm?: string | null
  serviceType?: string | null
  onePriceSupported?: boolean | null
  hsCode?: string | null
  specialRequirements?: string | null
  routeType?: string | null
  needPickup?: boolean | null
  needDelivery?: boolean | null
  needUpstairs?: boolean | null
  needLoadingUnloading?: boolean | null
  expectedVehicleType?: string | null
  expectedTransitTime?: string | null
  pricingPreference?: string | null
}

export interface InquiryExpressSubmitRequest {
  id: string | number
  inquiryTarget: number
  contactIds?: Array<string | number>
}

export interface InquiryExpressWithdrawRequest {
  id: string | number
}

export const pageInquiryExpress = (params: InquiryExpressPageRequest) => {
  return request.post<PageResponse<InquiryExpressModel>>('/price/inquiry/express/page', params)
}

export const getInquiryExpressById = (id: string) => {
  return request.post<InquiryExpressModel>('/price/inquiry/express/get', { id })
}

export const getInquiryExpressByInquiryNo = (inquiryNo: string) => {
  return request.post<InquiryExpressModel>('/price/inquiry/express/get', { inquiryNo })
}

export const saveInquiryExpress = (params: InquiryExpressSaveRequest) => {
  return request.post<string>('/price/inquiry/express/save', params)
}

export const updateInquiryExpress = (params: InquiryExpressSaveRequest) => {
  return request.post<boolean>('/price/inquiry/express/update', params)
}

export const submitInquiryExpress = (params: InquiryExpressSubmitRequest) => {
  return request.post<boolean>('/price/inquiry/express/submit', params)
}

export const withdrawInquiryExpress = (params: InquiryExpressWithdrawRequest) => {
  return request.post<boolean>('/price/inquiry/express/withdraw', params)
}

export const batchDeleteInquiryExpress = (params: BatchDeleteRequest) => {
  return request.post<boolean>('/price/inquiry/express/batch-delete', params)
}

export const updateConfirmedExpressQuotation = (params: { id: string; confirmedQuotationId: string | null }) => {
  return request.post<boolean>('/price/inquiry/express/update-confirmed-quotation', params)
}
